import { Link } from "react-router-dom";
import { ROUTES } from "../../routes/path";
import "../../styles/footer.css";

const columns = [
  {
    title: "IT Services",
    links: [
      { label: "Managed IT", to: "/services/managed-it" },
      { label: "IT Support", to: "/services/it-support" },
      { label: "IT Consultancy", to: "/services/it-consultancy" },
      { label: "Cloud Computing", to: "/services/cloud-computing" },
      { label: "Cyber Security", to: "/services/cyber-security" },
    ],
  },
  {
    title: "Quick links",
    links: [
      { label: "Where to Find Us", to: `${ROUTES.CONTACT}#google-location` },
    ],
  },
  {
    title: "Support",
    links: [
      { label: "Privacy Policy", to: ROUTES.PRIVACY },
      { label: "Terms & Conditions", to: ROUTES.TERMS },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About Us", to: ROUTES.ABOUT },
      { label: "Blogs", to: ROUTES.BLOG },
      { label: "Careers", to: ROUTES.CAREER },
      { label: "FAQs", to: ROUTES.FAQ },
      { label: "Contact Us", to: ROUTES.CONTACT },
    ],
  },
];

const offices = [
  // {
  //   country: "India",
  //   lines: [
  //     "Office no. 623, Centura Square IT Park,",
  //     "Thane, Maharashtra 400604, India",
  //   ],
  // },
  {
    country: "Global Tech9 LLC",
    lines: ["5900 Balcones Drive STE 100,", "Austin, TX 78731, USA"],
  },
];

const icons = {
  x: (
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  ),
  facebook: (
    <path d="M13.5 22v-8.2h2.8l.5-3.4h-3.3V8.3c0-1 .4-1.8 1.9-1.8h1.5V3.4c-.3 0-1.3-.1-2.4-.1-2.5 0-4.2 1.5-4.2 4.3v2.8H7.5v3.4h2.8V22z" />
  ),
  instagram: (
    <>
      <rect
        x="3"
        y="3"
        width="18"
        height="18"
        rx="5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <circle
        cx="12"
        cy="12"
        r="4"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <circle cx="17.3" cy="6.7" r="1.2" />
    </>
  ),
  linkedin: (
    <path d="M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM3 9.5h4V21H3zm6.5 0h3.8v1.6h.1c.5-1 1.8-1.9 3.7-1.9 4 0 4.7 2.6 4.7 6V21h-4v-5.1c0-1.2 0-2.8-1.7-2.8s-2 1.3-2 2.7V21h-4z" />
  ),
};

const socials = [
  { name: "X", href: "www.twitter.com", icon: "x" },
  { name: "Facebook", href: "www.facebook.com", icon: "facebook" },
  { name: "Instagram", href: "www.instagram.com", icon: "instagram" },
  { name: "LinkedIn", href: "www.linkedin.com", icon: "linkedin" },
];

const Footer = (props) => {
  return (
    <footer className="gt9-footer">
      {/* Call to action band */}
      <div className="gt9-container">
        <div className="gt9-cta">
          <div>
            <h2 className="gt9-cta__title">
              Need a dependable technology partner?
            </h2>
            <p className="gt9-cta__text">
              Talk to our team about managed IT, cloud, or security for your
              business.
            </p>
          </div>
          <Link to="/contact-us" className="gt9-cta__btn">
            Contact us
            <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
              <path
                d="M5 12h14M13 6l6 6-6 6"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Link>
        </div>
      </div>

      {/* Main grid */}
      <div className="gt9-container gt9-grid">
        <div className="gt9-brand">
          <Link to="/" className="gt9-logo" aria-label="Global Tech9 LLC home">
            <img src="/logo.png" alt="Global Tech9 LLC" />
          </Link>

          <div className="gt9-footer-offices">
            {offices.map((o) => (
              <address key={o.country} className="gt9-footer-office">
                <span className="gt9-office__country">{o.country}</span>
                {o.lines.map((l) => (
                  <span key={l}>{l}</span>
                ))}
              </address>
            ))}
          </div>

          <ul className="gt9-contact">
            <li>
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path
                  d="M3 6h18v12H3zM3 7l9 6 9-6"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.7"
                  strokeLinejoin="round"
                />
              </svg>
              <a href="mailto:contact@globaltech9.com">
                contact@globaltech9.com
              </a>
            </li>
            <li>
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path
                  d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.7"
                  strokeLinejoin="round"
                />
              </svg>
              <a href=" "></a>
            </li>
            <li>
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <circle
                  cx="12"
                  cy="12"
                  r="9"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.7"
                />
                <path
                  d="M3 12h18M12 3c3 3 3 15 0 18M12 3c-3 3-3 15 0 18"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.7"
                />
              </svg>
              <a
                href="https://www.globaltech9.com"
                target="_blank"
                rel="noreferrer"
              >
                www.globaltech9.com
              </a>
            </li>
          </ul>
        </div>

        {columns.map((col) => (
          <nav key={col.title} className="gt9-col" aria-label={col.title}>
            <h3 className="gt9-col__title">{col.title}</h3>
            <ul>
              {col.links.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="gt9-link">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        ))}
      </div>

      {/* Bottom bar */}
      <div className="gt9-container">
        <div className="gt9-bottom">
          <p>
            © {new Date().getFullYear()} Global Tech9 LLC. All rights reserved.
          </p>
          <ul className="gt9-social">
            {socials.map((s) => (
              <li key={s.name}>
                <a
                  href={s.href}
                  aria-label={s.name}
                  target="_blank"
                  rel="noreferrer"
                >
                  <svg
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    {icons[s.icon]}
                  </svg>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* <PrivacyModal open={legal === "privacy"} onClose={() => setLegal(null)} /> */}
      {/* <TermsModal open={legal === "terms"} onClose={() => setLegal(null)} onOpenPrivacy={() => setLegal("privacy")} /> */}
    </footer>
  );
};

export default Footer;
